// @ts-nocheck

class ProductDetailsMedia {
  constructor() {
    this.root = document.querySelector('[data-pdp-details]');
    if (!this.root) return;

    this.video = this.root.querySelector('.pdp-details__media video');
    this.toggle = this.root.querySelector('[data-pdp-media-toggle]');
    if (!this.video || !this.toggle) return;

    this.pauseIcon = this.toggle.querySelector('[data-pdp-icon-pause]');
    this.playIcon = this.toggle.querySelector('[data-pdp-icon-play]');

    this.toggle.addEventListener('click', () => this.togglePlayback());
    this.video.addEventListener('play', () => this.updateState());
    this.video.addEventListener('pause', () => this.updateState());
  }

  togglePlayback() {
    if (this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }

  updateState() {
    const isPaused = this.video.paused;
    this.toggle.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
    this.toggle.setAttribute('aria-label', isPaused ? 'Play video' : 'Pause video');
    if (this.pauseIcon) this.pauseIcon.hidden = isPaused;
    if (this.playIcon) this.playIcon.hidden = !isPaused;
  }
}

new ProductDetailsMedia();
